import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App } from "antd";

import { getShowProModal } from "redux/Modals/selectors";
import { setShowProModal } from "redux/Modals/actions";

import ProPlanUser from "./ProPlanUser";

function ProPlanModal() {
  const dispatch = useDispatch();
  const showModal = useSelector(getShowProModal);
  const { modal } = App.useApp();

  useEffect(() => {
    if (!showModal) return;

    const instance = modal.warning({
      title: `You Are On The Pro Plan`,
      content: <ProPlanUser showModal={showModal} />,
      width: 560,
      okText: "Contact Us",
      afterClose: () => {
        dispatch(setShowProModal(false));
      },
    });

    return () => {
      instance.destroy();
    };
  }, [showModal, modal, dispatch]);

  return null;
}

export default ProPlanModal;
